/* 喫煙区分 */
export default {
    // 禁煙
    NO_SMOKING: "1",
    // 喫煙
    SMOKING: "2",
    // おまかせ
    LEAVE: "3"
}